import { createFileRoute } from '@tanstack/react-router';
import { pricesQueryOptions } from '@utils/queryOptions';
import BillingSettings from '@Views/Settings/billing-settings';

export const Route = createFileRoute('/settings/_layout/billing')({
    component: BillingSettings,
    loader: opts => {
        opts.context.queryClient.ensureQueryData(pricesQueryOptions());
    },
});
